import styled from "styled-components";

export const PaymentMethodGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  margin-top: 10px;
  
  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const PaymentMethodCard = styled.div<{ isSelected?: boolean }>`
  flex: 1;
  border: 2px solid ${({ isSelected }) => (isSelected ? "var(--fixit)" : "var(--light-gray)")};
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
  background-color: ${({ isSelected }) => (isSelected ? "rgba(152, 53, 209, 0.08)" : "var(--white)")};
  transition: all 0.2s ease;

  svg {
    font-size: 28px;
    color: ${({ isSelected }) => (isSelected ? "var(--fixit)" : "var(--gray)")};
  }

  @media (max-width: 768px) {
    padding: 12px 8px;
    border-radius: 8px;
    svg { font-size: 24px; }
  }
`;

export const PlanTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: var(--black);
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const WarningLabel = styled.p`
  font-size: 12px;
  color: var(--error);
  margin-top: 10px;
  text-align: center;
  background-color: rgba(239, 83, 80, 0.1);
  padding: 8px 12px;
  border-radius: 6px;
  
  b {
    font-weight: bold;
  }
`;

export const PaymentTitle = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: var(--black);
  margin: 16px 0 8px 0;
  border-bottom: none;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 1rem;
`

export const Header = styled.div`
    display: none;
`

export const DepositLabel = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: var(--gray)
`

export const FixcoinBalance = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 5px;
`

export const Label = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: var(--gray)
`

export const FixCoinValue = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: var(--active-green);
`

export const PixBox = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 16px auto 0 auto;
  background-color: rgba(152, 53, 209, 0.05);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  border: 2px solid var(--fixit);
`;

export const QrCodeImage = styled.img`
  width: 200px;
  height: 200px;
  border-radius: 8px;
  border: 1px solid var(--light-gray);
`;

export const CopyPasteContainer = styled.div`
  width: 100%;
  background-color: var(--white);
  border: 1px dashed var(--gray);
  border-radius: 8px;
  padding: 32px 16px 16px 16px;
  position: relative;
  word-break: break-all;
  font-size: 14px;
  color: var(--dark-gray);
  text-align: left;
`;

export const CopyButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: transparent;
  color: var(--fixit);
  border: none;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: bold;
  font-size: 12px;
  transition: all 0.2s;

  &:hover {
    color: var(--black);
  }
`;

export const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(152, 53, 209, 0.2);
  border-left-color: var(--fixit);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 1rem 0 0;
`
